import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  LightDomStyles,
  OutlineElement,
  SlotsController,
} from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './outline-cta-card.css.lit';
import { classMap } from 'lit/directives/class-map.js';
import '../outline-button-baseline/outline-button-baseline';
import '../outline-icon-baseline/outline-icon-baseline';
import buttonStyles from '../outline-button-baseline/outline-button-baseline.css.lit';

/**
 * The OutlineCtaCard component
 * @element outline-cta-card
 */
@customElement('outline-cta-card')
export class OutlineCtaCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, buttonStyles];
  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  slots = new SlotsController(this);

  /**
   * Whether the card is high contrast.
   */
  @property({ type: Boolean, reflect: true, attribute: 'high-contrast' })
  highContrast = false;

  /**
   * Whether the card is a card image.
   */
  @property({ type: Boolean, reflect: true, attribute: 'card-image' })
  cardImage = false;

  /**
   * The card background color.
   */
  @property({ type: String, reflect: true, attribute: 'background-color' })
  backgroundColor = 'white-bg';

  render(): TemplateResult {
    return html`
      <article
        class=${classMap({
          'container': true,
          'card-image': this.cardImage,
          'high-contrast': this.highContrast,
          [this.backgroundColor]: true,
        })}
      >
        <div class="content">
          ${this.slots.conditionalSlot('image', false)}
          ${this.cardImage
            ? html`<div class="card-image-content-wrapper">
                ${this.slots.conditionalSlot('icon', false)}
                ${this.slots.conditionalSlot('heading', false)}
                ${this.slots.conditionalSlot('body', false)}
                ${this.slots.conditionalSlot('cta', true)}
              </div>`
            : html`
                ${this.slots.conditionalSlot('icon', false)}
                ${this.slots.conditionalSlot('heading', false)}
                ${this.slots.conditionalSlot('body', false)}
                ${this.slots.conditionalSlot('cta', true)}
              `}
        </div>
      </article>
    `;
  }
}
